/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Support_ColInputs */

const en_home_footer_support_col = /** @type {(inputs: Home_Footer_Support_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const fr_home_footer_support_col = /** @type {(inputs: Home_Footer_Support_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutien`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Home_Footer_Support_ColInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_support_col = /** @type {((inputs?: Home_Footer_Support_ColInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Support_ColInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_support_col(inputs)
	return fr_home_footer_support_col(inputs)
});